// extracted by mini-css-extract-plugin
module.exports = {"viewport":"GalleryBlock_viewport__EzfSR","slide":"GalleryBlock_slide__S1Nsc","imageContainer":"GalleryBlock_imageContainer__yh41g"};